import LazyVideo from '@cartwhl/ui/atoms/LazyVideo';

import { CDN } from 'consts';

export default function VideoSection() {
  return (
    <section className="pb-(--vertical-spacing)">
      <div className="md:container">
        <div className="bg-gray-15 relative aspect-video flex-1 overflow-hidden p-8 md:rounded-2xl">
          <LazyVideo
            src={`${CDN}05_data_page/01_data_header.webm`}
            className="absolute inset-0 h-full w-full rounded-[inherit]"
            mode="autoplay"
          />
        </div>
      </div>
    </section>
  );
}
